module.exports = require('./helpers/bundle-url').getBundleURL('sif1r') + "paratime-selector-glow-testnet.fa73b1cf.svg";